import React from 'react'
import PropTypes from 'prop-types'
import LocationPermissionStore from 'stores/locationPermissionStore'
import Constants from 'common/constants'
import 'styles/sidebar.css'
import Utils from 'common/utils';

export default class LocationPermissionView extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            permissionStatus: LocationPermissionStore.getPermissionStatus()
        }
        this.__locationPermissionListener = LocationPermissionStore.registerForPermissionChangeCb(this.permissionChangedCb.bind(this))
    }

    render() {
        let permissionLogo = "loc-permission-denied"
        switch (this.state.permissionStatus) {
            case Constants.LOCATION_PERMISSION_STATUS.DENIED:
            case Constants.LOCATION_PERMISSION_STATUS.INVALID:
                permissionLogo = "loc-permission-denied"
                break
            default:
                permissionLogo = "loc-permission-granted"
        }

        return (
            <div className="loc-permission-wrapper" onClick={() => {
                this.props.icon_clicked()
            }}>
                <img src={`/image/${permissionLogo}.svg`} alt={permissionLogo} />
            </div>
        )
    }

    componentWillUnmount() {
        if (false === Utils.isNull(this.__locationPermissionListener)) {
            LocationPermissionStore.unregisterForKey(this.__locationPermissionListener)
        }
    }

    permissionChangedCb() {
        let newStatus = LocationPermissionStore.getPermissionStatus()
        this.setState({
            permissionStatus: newStatus,
        })
    }
}

LocationPermissionView.propTypes = {
    icon_clicked: PropTypes.func.isRequired,
}


// WEBPACK FOOTER //
// ./src/components/locationPermissionView.js